export default {"src":"/login-app/[GIT_HASH]/_next/static/media/terminate.e5f3bf84.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};